import { React, useState, useEffect } from 'react'
import '../../layouts/stylesheets/loader-style.css'
import { AiTwotoneSnippets } from 'react-icons/ai'

const CampaignObjective = (props) => {
  const [loading] = useState(false)
  const [primaryCampaignObjective, setPrimaryCampaignObjective] = useState('')
  const [formErrors, setFormErrors] = useState({})

  const campaignObjectives = {
    google: [
      'Sales',
      'Leads',
      'Website traffic',
      'Product and brand consideration',
      'Brand awareness and reach',
      'App promotion',
    ],
    facebook: [
      'Awareness',
      'Traffic',
      'Engagement',
      'Leads',
      'App promotion',
      'Sales',
    ],
    linkedin: [
      'Awareness',
      'Consideration',
      'Website visits',
      'Engagement',
      'Video views',
      'Lead generation',
      'Job applicants',
      'Conversion',
      'Website conversions',
      'Event registrations',
    ],
    tiktok: ['Traffic', 'App installs', 'Video views', 'Conversions'],
    x: [
      'Awareness',
      'Consideration',
      'Promoted trends',
      'Website clicks or conversions',
      'App installs or engagements',
      'Video views',
      'Followers',
      'Conversion',
      'Lead generation',
    ],
    mailchimp: ['Conversion'],
    microsoft: [
      'Sales',
      'Leads',
      'Website traffic',
      'Product and brand consideration',
      'Brand awareness and reach',
      'App promotion',
    ],
  }

  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'forward') {
        if (primaryCampaignObjective === '') {
          setFormErrors((currentErrors) => ({
            ...currentErrors,
            name: 'Please select a campaign objective.',
          }))
          return
        } else {
          props.setActivePage('campaignDetails')
        }
      } else if (props.nav === 'back') {
        props.setActivePage('campaignType')
      }
    }
    handleNav(props)
  }, [props, primaryCampaignObjective])

  const handleSelect = (event) => {
    setPrimaryCampaignObjective(event.target.id)
    props.setCampaignData({
      ...props.campaignData,
      primaryCampaignObjective: event.target.id,
    })
  }

  return loading ? (
    <>
      <div className="loader-wrapper">
        <div className="flex justify-center items-center">
          <div className="grid gap-10">
            <div className="loader"></div>
            <div className="text-center font-unbounded">Loading...</div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className="mb-6 w-full max-w-5xl mx-auto h-auto px-4 overflow-x-clip">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div className="flex items-center col-span-full">
          <p className="w-full uppercase mx-auto flex items-center gap-2 font-unbounded">
            <AiTwotoneSnippets />
            Select Campaign Goal
          </p>
        </div>

        <h3 className="col-span-full w-full text-2xl font-unbounded">
          Set up your M-Link
        </h3>

        <p className="col-span-full w-full text-xl sm:text-lg font-light text-[#000000] mb-8 ">
          {
            'Choose your campaign objective. This helps us tailor your tracking setup and performance insights for optimal results.'
          }
        </p>

        {campaignObjectives[props.campaignData.platform].map(
          (campaignObjective) => (
            <div key={campaignObjective} className="w-full">
              <input
                id={campaignObjective}
                name="source"
                type="radio"
                className="hidden"
                onClick={handleSelect}
              />
              <label
                htmlFor={campaignObjective}
                className="radio-label font-unbounded h-14 flex justify-center items-center bg-metrinome-shadow-green text-black text-center rounded-3xl placeholder-black text-lg font-light w-full px-4 cursor-pointer"
              >
                {campaignObjective}
              </label>
            </div>
          )
        )}
      </div>

      {formErrors.name ? (
        <p
          className="mx-auto w-fit text-left font-bold p-2.5"
          style={{ color: '#f44' }}
        >
          {formErrors.name}
        </p>
      ) : (
        ''
      )}
    </div>
  )
}

export default CampaignObjective
